//-----------------------
// set combatant values
//-----------------------
export default function setCombatantValues(default_race) {
  let combatant = {
    slug: '',
    id: 0,
    sr_roll: 0,
    sr_adj: 0,
    roll_off: 0,
    race: default_race.name,
    category: 'Enemy',
    type: 'Troop',
    role: 'Default',
    player: '',
    status: 'Active',
    sub_status: 'Active',
    visibility: 'visible',
    ca: default_race.ca,
    cr: default_race.cr,
    dex: default_race.characteristics.find((c) => (c.name = 'DEX')).value,
    sr: default_race.sr,
    damage_mod: default_race.damage_mod,
    second_weapon: false,
    shield: false,
    ranged: false,
    magic: false,
    special_action: default_race.special_action,
    special_reaction: default_race.special_reaction,
    image: null,
  }
  return combatant
}
